import styled from "styled-components";

export const DeviceInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    padding-right: 5px;
    box-sizing: border-box;
`;

export const InfoGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    &:last-child {
        margin-bottom: 0; 
    }
`;

export const InfoGroupSeparator = styled.div`
    border-top: 1px solid #CCCCCC;
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const InfoGroupTitle = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 2px;
    margin: 15px 20px;
`;

export const InfoGroupContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: top;
    width: 100%;
`;

export const InfoColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;

    &:first-child {
        margin-top: 0px;
    }
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 32px;
`;

export const InfoLabel = styled.span`
    font-size: 13px;
    color: #555555;
    width: 35%;
    padding-left: 5px;
`;

export const InfoValue = styled.span`
    font-size: 13px;
    color: #101010;
    width: 65%;
    flex-direction: column;
`;

export const DeviceLocationMapWrapper = styled.div`
    width: 100%;
    height: 300px;
    border-radius: 5px;
    overflow: hidden;
    padding-top: 5px;
`;
export const DeviceMetricChartsMapWrapper = styled.div`
    width: 100%;
`;